import React from "react";
import { Link } from "react-router-dom";
import HeaderMessage from "./components/HeaderMessage/HeaderMessage";
import MobileNav from "./components/MobileNav/MobileNav";
import NavMenu from "./components/NavMenu/NavMenu";
import styles from "./Header.module.scss";

const isTest = import.meta.env.NODE_ENV === "test";

interface Props {
  isMobile: boolean;
  isAuthenticated: boolean;
}

const Header: React.FC<Props> = ({ isAuthenticated, isMobile }) => {
  return (
    <div className={styles.container}>
      <Link to={`/`}>
        <img className={styles.logo} src="/logo_dark.png" alt="longbow logo" />
      </Link>

      {/* ignore component in test environment */}
      {!isTest ? <HeaderMessage /> : null}

      {isMobile ? (
        <MobileNav isAuthenticated={isAuthenticated} />
      ) : (
        <NavMenu isAuthenticated={isAuthenticated} />
      )}
    </div>
  );
};

export default Header;
